import React, { useContext } from 'react';
import { ServiceRequestData } from '@services/types/Relationship/MyCalls/types';
import CustomTag from '@components/CustomTag';
import SessionContext from '@providers/Session/SessionContext';
import { Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MessagesActions, { MessagesActionNames } from './MessagesActions';
import MessagesAttachments from './MessagesAttachments';
import * as S from './styles';

interface MessagesHeaderProps {
  request?: ServiceRequestData;
  onMutateRequest?: (action: MessagesActionNames, requestId: number) => void;
}

const MessagesHeader = ({ request, onMutateRequest }: MessagesHeaderProps) => {
  const { t } = useTranslation('service-requests');
  const { isRoot } = useContext(SessionContext);

  return (
    <S.RequestHeaderContainer>
      <div>
        <CustomTag color={request?.treatedStatus?.value ? 'green' : 'red'}>
          {request?.treatedStatus?.label?.toUpperCase()}
        </CustomTag>
        {request?.subStatus?.name === 'EM ANDAMENTO' && (
          <Button
            type="link"
            icon={<LoadingOutlined />}
            style={{ marginLeft: -8, cursor: 'default' }}
          >
            {t('inProgress')}
          </Button>
        )}
      </div>
      <div>
        <MessagesAttachments request={request} />
        {request?.treatedStatus?.value && isRoot && (
          <MessagesActions
            request={request}
            onMutateRequest={onMutateRequest}
          />
        )}
      </div>
    </S.RequestHeaderContainer>
  );
};

export default MessagesHeader;
